"use strict";
var _a, _b, _c, _d, _e, _f, _g;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityPlacementSlipInstallementDetail = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_placement_slip_generation_entity_1 = require("./opportunity-placement-slip-generation.entity");
/**
 * Entity for opportunity_placement_slip_installement_detail table.
 */
let OpportunityPlacementSlipInstallementDetail = class OpportunityPlacementSlipInstallementDetail {
    constructor(placementSlipId, firstInstallmentDate, secondInstallmentDate, createdBy, updatedBy) {
        this.placementSlipId = placementSlipId;
        this.firstInstallmentDate = firstInstallmentDate;
        this.secondInstallmentDate = secondInstallmentDate;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
    }
};
exports.OpportunityPlacementSlipInstallementDetail = OpportunityPlacementSlipInstallementDetail;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipInstallementDetail.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "placement_slip_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipInstallementDetail.prototype, "placementSlipId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "first_installment_date", type: "date", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], OpportunityPlacementSlipInstallementDetail.prototype, "firstInstallmentDate", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "second_installment_date", type: "date", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], OpportunityPlacementSlipInstallementDetail.prototype, "secondInstallmentDate", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipInstallementDetail.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipInstallementDetail.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object)
], OpportunityPlacementSlipInstallementDetail.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_f = typeof Date !== "undefined" && Date) === "function" ? _f : Object)
], OpportunityPlacementSlipInstallementDetail.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_placement_slip_generation_entity_1.OpportunityPlacementSlipGeneration, (placement) => placement.installmentDates),
    (0, typeorm_1.JoinColumn)({ name: "placement_slip_id" }),
    tslib_1.__metadata("design:type", typeof (_g = typeof opportunity_placement_slip_generation_entity_1.OpportunityPlacementSlipGeneration !== "undefined" && opportunity_placement_slip_generation_entity_1.OpportunityPlacementSlipGeneration) === "function" ? _g : Object)
], OpportunityPlacementSlipInstallementDetail.prototype, "placementSlip", void 0);
exports.OpportunityPlacementSlipInstallementDetail = OpportunityPlacementSlipInstallementDetail = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_placement_slip_installement_detail"),
    tslib_1.__metadata("design:paramtypes", [Number, typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object, typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object, Number, Number])
], OpportunityPlacementSlipInstallementDetail);
